module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "quote-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Quote',
          to: {
            path: '/quote'
          },
        },
        {
          text: !_vm.$route.query.id ? 'Tambah Quote' : 'Ubah Quote'
        } ],
      "divider": ">"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(!_vm.$route.query.id ? "Tambah Quote" : "Ubah Quote") + "\n    ")]), _vm._v(" "), _c('v-card', {
    staticClass: "pa-4",
    attrs: {
      "plain": ""
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Quotes\n                ")]), _vm._v(" "), _c('v-textarea', {
    ref: "quote",
    attrs: {
      "counter": "",
      "placeholder": "Quote",
      "rules": _vm.rules,
      "outlined": ""
    },
    model: {
      value: (_vm.form.quote),
      callback: function($$v) {
        _vm.$set(_vm.form, "quote", $$v)
      },
      expression: "form.quote"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Level\n                ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "outlined": "",
      "placeholder": "Pilih Level",
      "items": _vm.levelList,
      "item-text": "level_name",
      "item-value": "level_id"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item', {
          staticClass: "pa-0 ma-0"
        }, [_c('v-list-item-title', [_vm._v(_vm._s(item.level_name))])], 1)]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item-title', [_vm._v(_vm._s(item.level_name))])]
      }
    }]),
    model: {
      value: (_vm.form.level_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "level_id", $$v)
      },
      expression: "form.level_id"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-6 py-2 white--text",
    attrs: {
      "depressed": "",
      "color": "blew"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("\n                Simpan")])], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9053f44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_meter/components/QuoteForm.vue
// module id = 992
// module chunks = 1